import clsx from 'clsx'
import { memo, ReactNode } from 'react'

import styles from './MorePaginationButton.module.scss'

export type MorePaginationButtonProps = {
	onClick: () => void
	disabled?: boolean
	ariaLabel: string
	className?: string
	children?: ReactNode
}

/**
 * A button that is used to load more product items.
 * @param props
 * @param props.disabled
 * @param props.ariaLabel
 * @param props.children
 *  */
export const MorePaginationButton = memo(
	({ onClick, disabled, ariaLabel, className, children }: MorePaginationButtonProps): JSX.Element => (
		<button
			className={clsx(styles.morePaginationButton, className, disabled && styles['morePaginationButton--disabled'])}
			aria-label={ariaLabel}
			onClick={onClick}
			disabled={disabled}
			type="button">
			{children}
		</button>
	)
)
